import App from 'App';
import MainLayout from 'layouts/MainLayout';
import Error404 from 'pages/error/Error404';
import SimpleForgotPassword from 'pages/pages/authentication/simple/ForgotPassword';
import {
  default as ResetPassword,
  default as SimpleResetPassword
} from 'pages/pages/authentication/simple/ResetPassword';
import SimpleSignIn from 'pages/pages/authentication/simple/SignIn';
import SimpleSignOut from 'pages/pages/authentication/simple/SignOut';
import SimpleTwoFA from 'pages/pages/authentication/simple/TwoFA';
import MainLayoutProvider from 'providers/MainLayoutProvider';
import { Navigate, RouteObject, createBrowserRouter } from 'react-router-dom';

import ProjectManagement from 'pages/dashboard/ProjectManagement';

import RewardDrinkList from 'pages/reward/drink/RewardDrinkList';
import RewardDrinkCreate from 'pages/reward/drink/RewardDrinkCreate';
import RewardDrinkEdit from 'pages/reward/drink/RewardDrinkEdit';

import RewardChallengeList from 'pages/reward/challenge/RewardChallengeList';
import RewardChallengeCreate from 'pages/reward/challenge/RewardChallengeCreate';
import RewardChallengeEdit from 'pages/reward/challenge/RewardChallengeEdit';

import FeePayerWalletDetails from 'pages/feepayer/wallet/Details';
import CreateFeePayerWallet from 'pages/feepayer/wallet/Create';
import FeePayerWalletList from 'pages/feepayer/wallet/List';

import FlywheelWallet from 'pages/flywheel/Wallet';

import PrivateSettings from 'pages/settings/private/PrivateSettings';
import PublicSettings from 'pages/settings/public/PublicSettings';

import ClaimNormalList from 'pages/claim/normal/ClaimNormalList';
import ClaimReferralList from 'pages/claim/referral/ClaimReferralList';
import ECharts from 'pages/modules/charts/ECharts';

import PrivacyPolicy from './pages/pages/static/PrivacyPolicy';
import ContactUs from './pages/pages/static/ContactUs';

import UserList from './pages/users/UserList';
import UserDetails from './pages/users/UserDetails';

import RewardClaimTransactionList from 'pages/transactions/RewardClaimTransactionList';

import NormalPointReward from 'pages/reward/NormalPointRewardList';
import ReferralPointRewardList from 'pages/reward/ReferralPointRewardList';

import DashBoardSummary from 'pages/dashboard/DashBoardSummary';

import InvestorAirdrop from 'pages/investor-airdrop/InvestorAirdrop';

const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      {
        path: '',
        element: (
          <MainLayoutProvider>
            {' '}
            <MainLayout />{' '}
          </MainLayoutProvider>
        ),
        children: [
          {
            path: '/dashboard',
            children: [
              {
                path: '',
                element: <Navigate to="summary" replace />
              },
              {
                path: 'summary',
                element: <DashBoardSummary />
              }
            ]
          },
          {
            path: '/reward-rules',
            children: [
              {
                path: '',
                element: <Navigate to="drink" replace />
              },
              {
                path: 'drink',
                element: <RewardDrinkList />
              },
              {
                path: 'drink/add',
                element: <RewardDrinkCreate />
              },
              {
                path: 'drink/:id/edit',
                element: <RewardDrinkEdit />
              },
              {
                path: 'challenge',
                element: <RewardChallengeList />
              },
              {
                path: 'challenge/add',
                element: <RewardChallengeCreate />
              },
              {
                path: 'challenge/:id/edit',
                element: <RewardChallengeEdit />
              }
            ]
          },
          {
            path: '/reward-claim',
            element: <RewardClaimTransactionList />
          },
          {
            path: '/referral-points-reward',
            element: <ReferralPointRewardList />
          },
          {
            path: '/normal-points-reward',
            element: <NormalPointReward />
          },
          {
            path: 'claim-request',
            children: [
              {
                path: '',
                element: <Navigate to="normal" replace />
              },
              {
                path: 'normal',
                element: <ClaimNormalList />
              },
              {
                path: 'referral',
                element: <ClaimReferralList />
              }
            ]
          },
          {
            path: 'users',
            children: [
              {
                path: '',
                element: <UserList />
              },
              {
                path: ':id/details',
                element: <UserDetails />
              }
            ]
          },
          {
            path: 'feepayer-wallet',
            children: [
              {
                path: '',
                element: <Navigate to="drink" replace />
              },
              {
                path: 'list',
                element: <FeePayerWalletList />
              },
              {
                path: 'details',
                element: <FeePayerWalletDetails />
              },
              {
                path: 'generate',
                element: <CreateFeePayerWallet />
              }
            ]
          },
          {
            path: 'flywheel-wallet',
            element: <FlywheelWallet />
          },
          {
            path: 'investor-airdrop',
            element: <InvestorAirdrop />
          },
          {
            path: 'settings',
            children: [
              {
                path: '',
                element: <Navigate to="public" replace />
              },
              {
                path: 'public',
                element: <PublicSettings />
              },
              {
                path: 'private',
                element: <PrivateSettings />
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/auth/',
    children: [
      {
        path: 'login',
        element: <SimpleSignIn />
      },
      {
        path: 'verify-2fa',
        element: <SimpleTwoFA />
      },
      {
        path: 'reset/:token',
        element: <ResetPassword />
      },
      {
        path: 'logout',
        element: <SimpleSignOut />
      },
      {
        path: 'forgot-password',
        element: <SimpleForgotPassword />
      },
      {
        path: 'reset-password',
        element: <SimpleResetPassword />
      }
    ]
  },
  {
    path: 'privacy-policy',
    element: <PrivacyPolicy />
  },
  {
    path: 'contact-us',
    element: <ContactUs />
  },
  {
    path: '*',
    element: <Error404 />
  }
];

export const router = createBrowserRouter(routes);

export default routes;
